/**
 * This class returns all of the stripe subscription attached to a certain user
 */

import Transaction from '../model/Transaction';
import Result from './Result';

class GetStripeSubscriptionResult extends Result {
	private _active_subscription : Transaction | null

	/**
	 * @param success whether the request was successfully
	 * @param message contains the error if the request was unsuccessful
	 * @param trasactionList a list of stripe transactions for the logged in users
	 */
	constructor(
		success: boolean,
		message: string,
		active_subscription : Transaction | null
	) {
		super(success, message);
		this._active_subscription = active_subscription
	}

	get active_subscription(): Transaction | null {
		return this._active_subscription;
	}
}

export default GetStripeSubscriptionResult;
